export const AUDIENCE_UNAUTHORIZED_TYPE = "unauthorized";
export const AUDIENCE_AUTHORIZED_TYPE = "authorized";

export const audienceOptions = [
  { value: AUDIENCE_AUTHORIZED_TYPE, label: "Авторизованные" },
  { value: AUDIENCE_UNAUTHORIZED_TYPE, label: "Неавторизованные" },
];

export const DISTRIBUTION_SALE_TYPE = "sale";
export const DISTRIBUTION_EXCLUSIVE_TYPE = "exclusive";
export const DISTRIBUTION_SPECIAL_TYPE = "special_for_you";
export const DISTRIBUTION_BIRTHDAY_TYPE = "birthday";

export const distributionTypeOptions = [
  { value: DISTRIBUTION_SALE_TYPE, label: "Акции" },
  { value: DISTRIBUTION_EXCLUSIVE_TYPE, label: "Эксклюзивное предложение" },
  { value: DISTRIBUTION_SPECIAL_TYPE, label: "Специально для вас" },
  { value: DISTRIBUTION_BIRTHDAY_TYPE, label: 'Поздравление с ДР' },
];

export const GENDER_MALE_TYPE = "male";
export const GENDER_FEMALE_TYPE = "female";

export const genderOptions = [
  { value: GENDER_MALE_TYPE, label: "Мужской" },
  { value: GENDER_FEMALE_TYPE, label: "Женский" },
];
